let auth_token;

console.log("auth_token herexxx:", auth_token);

export const setAuthToken = (token) => {
    auth_token = token
}

export const getAuthToken = () => {
    return auth_token
}
